import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/banner/BannerCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/banner/tournaments/TournamentItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/home/HomeTab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/navbar/NavigationStructure.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/carousel.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/separator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/features/footer/SealScriptLoader.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/VisualEditing.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/react-slot-counter/lib/index.esm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/footer/bac.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/footer/bitcoin.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/footer/Sponsors/GENESIS.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/footer/Sponsors/h.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/footer/Sponsors/JUTICALPA.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/footer/Sponsors/ligahondubet.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/footer/Sponsors/LOBOS-UPNFM.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/footer/Sponsors/marathon.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/footer/Sponsors/Motagua.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/footer/Sponsors/OLANCHO.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/footer/Sponsors/OLIMPIA.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/footer/Sponsors/REAL-SOCIEDAD.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/footer/Sponsors/RealDE.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/footer/Sponsors/VICTORIA.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/footer/tigo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/footer/visamaster.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/icons/honduras2.png");
